import { MouseEvent, MouseEventHandler, ReactNode, useCallback } from "react";

import {
  useRecentlyViewed,
  useRecentlyViewedPage,
  useRecentlyViewedPages
} from "providers/RecentlyViewed/RecentlyViewedProvider";
import { IconName } from "components/Icons";

export default function ExtLink({
  className,
  to,
  id,
  onClick,
  disabled,
  children,
  tracked = false,
  trackedTitle,
  iconName
}: {
  className?: string;
  to: string;
  id?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  disabled?: boolean
  children: ReactNode;
  tracked?: boolean;
  trackedTitle?: string;
  iconName?: IconName;
}) {
  const recentlyViewedContext = useRecentlyViewed();
  const { changeRecentlyViewedPages, isTracked } = useRecentlyViewedPages();
  const recentlyViewedPage = useRecentlyViewedPage();

  const clickHandler = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    if (isTracked(to)) {
      (recentlyViewedContext?.changeRecentlyViewedPages || changeRecentlyViewedPages)({
        action: "push",
        page: {
          ...recentlyViewedPage,
          location: to,
          pinned: false,
          title: trackedTitle || recentlyViewedPage?.title,
          iconName: iconName || recentlyViewedPage?.iconName
        }
      });
    }

    return onClick?.(event);
  }, [ isTracked, onClick, to, recentlyViewedContext, changeRecentlyViewedPages, recentlyViewedPage, trackedTitle, iconName ]);


  if (disabled) {
    return <span className={ className }>
      {children}
    </span>
  }
  return (
    <a
      className={ className }
      target="_blank"
      id={id}
      rel="noreferrer"
      href={to}
      onClick={ tracked ? clickHandler : onClick }
    >
      {children}
    </a>
  );
}
